import { render, staticRenderFns } from "./VeJwGzzjModal.vue?vue&type=template&id=18c7f6a5"
import script from "./VeJwGzzjModal.vue?vue&type=script&lang=js"
export * from "./VeJwGzzjModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports